// VariationNoRepeatBooksTask.js
// Wariacje bez powtórzeń — układanie k książek na półce (z n książek)

import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// V(n,k) = n*(n-1)*...*(n-k+1) dla k<=n; w przeciwnym razie 0
function permutationsNoRepeat(n, k) {
  if (k < 0 || k > n) return 0;
  let res = 1;
  for (let i = 0; i < k; i++) res *= (n - i);
  return res;
}

export function generateTask() {
  const n = Math.floor(Math.random() * 7) + 6; // 6..12
  const k = Math.min(Math.floor(Math.random() * 3) + 3, n); // 3..5, k<=n
  const answer = permutationsNoRepeat(n, k);

  return {
    type: "VariationNoRepeatBooksTask",
    data: { n, k, answer },
  };
}

export function renderTask({ data }) {
  const { n, k } = data;
  return (
    <div style={{ textAlign: "left" }}>
      <p>
        Masz <InlineMath math={`${n}`} /> różnych książek. Na półce jest tylko{" "}
        <InlineMath math={`${k}`} /> miejsc, a pozostałe książki możesz odłożyć do szuflady.
      </p>
      <p>
        Na ile sposobów można ustawić <InlineMath math={`${k}`} /> książek na półce?
      </p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label=""
      placeholder="Wpisz liczbę ułożeń"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") {
    return { correct: false, message: "Podaj liczbę." };
  }
  const given = parseInt(userAnswer.raw, 10);
  if (Number.isNaN(given)) {
    return { correct: false, message: "Podaj liczbę całkowitą." };
  }
  const correct = given === data.answer;
  userAnswer.correctAnswer = data.answer;
  return { correct, message: correct ? "Dobrze!" : "Spróbuj ponownie." };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`${data.answer}`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`${userAnswer.raw}`} />;
}

export function renderExplanation({ data }) {
  const { n, k, answer } = data;

  // budujemy zapis n*(n-1)*...*(n-k+1)
  const factors = Array.from({ length: k }, (_, i) => n - i);
  const productLatex = factors.join("\\cdot");

  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1. Dedukcja i wzór.</strong> Układamy książki na konkretnych miejscach na półce,
        a tej samej książki nie możemy użyć dwa razy. To są <b>wariacje bez powtórzeń</b>:
      </p>
      <BlockMath math={'V(n,k)=\\dfrac{n!}{(n-k)!}=n\\cdot(n-1)\\cdot\\ldots\\cdot(n-k+1)'} />

      <p><strong>Krok 2. Podstawienie i obliczenie.</strong></p>
      <BlockMath math={`V(${n},${k}) = ${productLatex} = ${answer}`} />
    </div>
  );
}
